import { DatePicker, Select } from 'antd';
import dayjs, { type Dayjs } from 'dayjs';
import { CollapsibleSection } from '@/shared/ui/CollapsibleSection';
import type { AdminStudyFilterOptions } from './useAdminStudyFilterOptions';
import styles from './AdminStudyFilterRail.module.css';

interface AdminStudyDetailsSectionProps {
  dateRange: [string, string] | null;
  onDateRangeChange: (range: [string, string] | null) => void;
  selectedPriorities: string[];
  onPrioritiesChange: (v: string[]) => void;
  selectedModalities: string[];
  onModalitiesChange: (v: string[]) => void;
  priorityOptions: AdminStudyFilterOptions['priorityOptions'];
  modalityOptions: AdminStudyFilterOptions['modalityOptions'];
}

export default function AdminStudyDetailsSection({
  dateRange,
  onDateRangeChange,
  selectedPriorities,
  onPrioritiesChange,
  selectedModalities,
  onModalitiesChange,
  priorityOptions,
  modalityOptions,
}: AdminStudyDetailsSectionProps) {
  const count =
    (dateRange ? 1 : 0) + selectedPriorities.length + selectedModalities.length;

  const handleRangePicker = (
    _dates: [Dayjs | null, Dayjs | null] | null,
    dateStrings: [string, string]
  ) => {
    if (dateStrings[0] && dateStrings[1]) {
      onDateRangeChange(dateStrings);
    } else {
      onDateRangeChange(null);
    }
  };

  const clearAll = () => {
    onDateRangeChange(null);
    onPrioritiesChange([]);
    onModalitiesChange([]);
  };

  return (
    <CollapsibleSection title="Study Details" count={count} onClear={clearAll}>
      <div className={styles.filterGroup}>
        <span className={styles.filterLabel}>Study Date</span>
        <DatePicker.RangePicker
          className={styles.fullWidth}
          value={dateRange ? [dayjs(dateRange[0]), dayjs(dateRange[1])] : null}
          onChange={handleRangePicker}
        />
      </div>
      <div className={styles.filterGroup}>
        <label htmlFor="admin-priority" className={styles.filterLabel}>
          Priority
        </label>
        <Select
          id="admin-priority"
          mode="multiple"
          allowClear
          placeholder="All"
          value={selectedPriorities}
          onChange={onPrioritiesChange}
          options={priorityOptions}
          className={styles.fullWidth}
        />
      </div>
      <div className={styles.filterGroup}>
        <label htmlFor="admin-modality" className={styles.filterLabel}>
          Modality
        </label>
        <Select
          id="admin-modality"
          mode="multiple"
          allowClear
          placeholder="All"
          value={selectedModalities}
          onChange={onModalitiesChange}
          options={modalityOptions}
          className={styles.fullWidth}
        />
      </div>
    </CollapsibleSection>
  );
}
